module.exports = __webpack_public_path__ + "static/tecvalco-logo-9c86afa14f6238c47e9f68e28f5ae91c.jpg";